<template>
    <div class="content-wrapper remove_table_shadow">
      <app-table
        :id="tableId"
        :options="options"
        @action="getListAction"
      />
  
      <div
        class="card card-with-search border-0 card-with-shadow d-none"
        v-for="(item, index) in packages"
        :key="index"
      >
        <div
          class="
            card-header
            d-flex
            justify-content-between
            align-items-center
            p-primary
            bg-transparent
          "
        >
          <h5 class="card-title d-inline-block mb-0">{{ item.title }}</h5>
        </div>
        <div class="card-body">
          <div class="text-justify" v-for="inc in item.include" :key="inc">
            {{ inc }}
          </div>
        </div>
  
        <app-button
          :label="$t('purchase_now')"
          class-name="btn-success mr-2"
          :is-disabled="false"
          @submit="btnSubmit(item.id)"
        />
      </div>
  
  <packages-addmodal
        v-if="isAddEditModalActive"
        :table-id="tableId"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
      />

      <certificate-description-modal
        v-if="isDescriptionModalActive"
        :detail="descriptionDetail"
        @close-modal="closeDescriptionModal"
      />
  
      <app-delete-modal
        v-if="deleteConfirmationModalActive"
        :preloader="deleteLoader"
        modal-id="demo-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
      />
  
      <certificate-view
        v-if="isCertificateViewModalActive"
        :certificate_id="certificateId"
        :company_id="companyId"
        :assignedTo="assigned_to"
        @close-modal="closeCertificateViewModal"
      />
    </div>
  </template>
  
  <script>
  import CoreLibrary from "../../../../core/helpers/CoreLibrary";
  import * as actions from "../../../Config/ApiUrl";
  import { TableHelpers } from "../Demo/Tables/mixins/TableHelpers";
  import AppFunction from "../../../../core/helpers/app/AppFunction";
  import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper.js";
  import { Input } from "element-ui";
  import {CERTIFICATE_VIEW} from "../../../Config/ApiUrl";
  import CertificateDescriptionModal from "../Client/Buyer/Certificate/CertificateDescriptionModal.vue";
  
  export default {
    extends: CoreLibrary,
    name: "TrainingList",
    mixins: [TableHelpers],
    components: {
      CertificateDescriptionModal,
    },
    data() {
      return {
        isDescriptionModalActive: false,
        descriptionDetail: {},
        isCertificateViewModalActive: false,
        certificateId: 0,
        companyId: 0,
        assigned_to: 0,
        packages: {},
        isAddEditModalActive: false,
        deleteConfirmationModalActive: false,
        deleteLoader: false,
        selectedUrl: "",
        tableId: "advance-table",
        rowData: {},
        input: {},
        options: {
          name: "AdvanceTable",
          url: actions.COMPANY_CERTIFICATE_LIST,
          // url: actions.DATATABLE_DATA,
          showHeader: true,
          columns: [
            {
              title: this.$t("title"),
              type: "custom-html",
              key: "title",
              modifier: (value, row) => {
                return `<span>${this.$t(row.display_title || value)}</span>`;
              },
            },
            {
              title: this.$t("description"),
              type: "custom-html",
              key: "description",
              modifier: (value, row) => {
                const triggerId = `training-certificate-description-${row.id}`;
                this.bindDescriptionTrigger(triggerId, row);
                return `<button type="button" id="${triggerId}" class="btn btn-link p-0">${this.$t("view")}</button>`;
              },
            },
            {
              title: this.$t("status"),
              type: "custom-html",
              key: "user_certificates",
              modifier: (value) => {
                var status;
                if (value) {
                  return `<span class="badge badge-sm badge-pill badge-success">${this.$t(value ? value.status : '---')}</span>`;
                }
                else {
                  return `<span>---</span>`;
                }

              },
            },
            {
              title: this.$t("issue_date"),
              type: "custom-html",
              key: "user_certificates",
              modifier: (value) => {
                return `<span>${this.$t(value ? value.issue_date : '---')}</span>`;
              },
            },
            {
              title: this.$t("expiry_date"),
              type: "custom-html",
              key: "user_certificates",
              modifier: (value) => {
                return `<span>${this.$t(value ? value.due_date : '---')}</span>`;
              },
            },
          ],
          actions: [
            // {
            //   title: this.$t("edit"),
            //   icon: "edit",
            //   type: "none",
            //   component: "app-add-modal",
            //   modalId: "demo-add-edit-Modal",
            // },
            // {
            //   title: this.$t("delete"),
            //   icon: "trash",
            //   type: "none",
            //   component: "app-confirmation-modal",
            //   modalId: "demo-delete",
            // },
            {
              title: this.$t("view"),
              icon: "eye",
              type: "none",
              component: "app-add-modal",
              modalId: "demo-add-edit-Modal",
            },
          ],
          filters: [
            // {
            //     "title": this.$t('date'),
            //     "type": "range-picker",
            //     "key": "date",
            //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
            // },
            // {
            //     "title": this.$t('age'),
            //     "type": "range-filter",
            //     "key": "age-range",
            //     "maxTitle": this.$t('max_age'),
            //     "minTitle": this.$t('min_age'),
            //     "sign": ""
            // },
            // {
            //     "title": this.$t('status'),
            //     "type": "checkbox",
            //     "key": "status",
            //     "option": [
            //         {id: 'active', value: 'Active'},
            //         {id: 'inactive', value: 'Inactive'},
            //         {id: 'invited', value: 'Invited'},
            //     ],
            // },
            // {
            //     "title": this.$t('gender'),
            //     "type": "radio",
            //     "key": "filter-with-gender",
            //     "option": [
            //         {id: 'male', value: 'Male'},
            //         {id: 'female', value: 'Female'},
            //         {id: 'other', value: 'Other'},
            //     ],
            //     "header": {
            //         "title": this.$t('want_to_filter_your_list'),
            //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
            //     },
            // },
            // {
            //     "title": this.$t('search_and_select'),
            //     "type": "drop-down-filter",
            //     "key": "search select",
            //     "option": [],
            // }
          ],
          showFilter: true,
          showSearch: true,
          showCount: true,
          showClearFilter: true,
          paginationType: "pagination",
          responsive: true,
          rowLimit: 10,
          showAction: true,
          orderBy: "desc",
          actionType: "default",
        },
      };
    },
    created() {
      this.options.columns = [...this.options.columns, this.actionObj];
      this.searchAndSelectFilterOptions();
    },
    mounted() {
      // this.getPackages();
      var company_id, user_id, urlParams;
      if (this.$attrs['props']?.type) {
        user_id = this.$store.state.user.loggedInUser.id;
        urlParams = '?type=employee_certification&user_id=' + user_id;
      }
      else {
        company_id = this.$store.state.userCompanyProfile.dataProfile.company_id;
        user_id = this.$store.state.userCompanyProfile.dataProfile.id;
        urlParams = '/'+company_id+'?user_id='+user_id+'&type=employee_certification';
      }
      this.options.url = actions.COMPANY_CERTIFICATE_LIST+urlParams;
      
      setTimeout(() => {
        $( ".remove_table_shadow .h-100 .datatable .table-responsive " ).removeClass("shadow");
      }, 1000);
    },
    methods: {
      /**
       * for open add edit modal
       */
      openAddEditModal() {
        this.isAddEditModalActive = true;
      },
  
      /**
       * for close add edit modal
       */
      closeAddEditModal() {
        $("#demo-add-edit-Modal").modal("hide");
        this.isAddEditModalActive = false;
        this.searchAndSelectFilterOptions();
        this.reSetData();
      },
      closeDescriptionModal() {
        $("#certificate-description-modal").modal("hide");
        this.isDescriptionModalActive = false;
        this.descriptionDetail = {};
      },
  
      /**
       * $emit Form datatable action
       */
      getListAction(rowData, actionObj, active) {
        this.rowData = rowData;
  
        if (actionObj.title == "Delete") {
          this.openDeleteModal();
        } else if (actionObj.title == this.$t("view")) {
          // window.location = '/admin/certificate/view/'+rowData.id;
          this.view(rowData);
        }
      },
      view(rowData) {
        const assignedCertificate = rowData.user_certificates || rowData.pivot || null;

        if (!assignedCertificate || !assignedCertificate.id) {
          this.$toastr.w("This course is not assigned yet.");
          return;
        }

        this.certificateId = rowData.id;
        this.companyId = assignedCertificate.company_id || 0;
        this.assigned_to = assignedCertificate.assigned_to || 0;
        // Extract the protocol and host from the current URL
        const { protocol, host } = window.location;

// Create the base URL using the protocol and host
        let companyCertificateId = assignedCertificate.id
        const baseUrl = `${protocol}//${host}`;
        const route = CERTIFICATE_VIEW+'/'+companyCertificateId;
        const url = baseUrl + route;
        // Open a new tab with the URL
        window.open(url, '_blank');
        // this.getCertificate();
        // this.isCertificateViewModalActive = true;
      },
      openDescriptionModal(rowData) {
        this.descriptionDetail = rowData;
        this.isDescriptionModalActive = true;
      },
      bindDescriptionTrigger(triggerId, row) {
        setTimeout(() => {
          const trigger = document.getElementById(triggerId);
          if (trigger && !trigger.dataset.descriptionBound) {
            trigger.dataset.descriptionBound = "true";
            trigger.addEventListener("click", (event) => {
              event.preventDefault();
              this.openDescriptionModal(row);
            });
          }
        }, 0);
      },
      getCertificate() {
        axiosGet(CERTIFICATE_VIEW+'/'+this.certificateId+'?company_id='+this.companyId)
            .then((res) => {
              // Open a new window or tab
              const newWindow = window.open();

              // Write the HTML content to the new window/tab
              newWindow.document.open();
              newWindow.document.write(res.data.result.view);
              // this.certificate = res.data.result.view;
              // this.disclaimer = res.data.result.disclaimer;
            })
            .catch((error) => {

            });
      },
      closeCertificateViewModal() {
        this.certificateId = 0;
        $("#certificate-view-Modal").modal("hide");
        this.isCertificateViewModalActive = false;
      },
  
      /**
       * for open confirmation modal
       */
      openDeleteModal() {
        this.deleteConfirmationModalActive = true;
      },
  
      /**
       * confirmed $emit Form confirmation modal
       */
      confirmed() {
        let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
        this.deleteLoader = true;
        this.axiosGet(url)
          .then((response) => {
            this.deleteLoader = false;
            $("#demo-delete").modal("hide");
            this.cancelled();
            this.$toastr.s(response.data.message);
            this.searchAndSelectFilterOptions();
          })
          .catch(({ error }) => {
            // Trigger after error
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
      },
  
      /**
       * cancelled $emit Form confirmation modal
       */
      cancelled() {
        this.deleteConfirmationModalActive = false;
        this.reSetData();
      },
      reSetData() {
        this.rowData = {};
        this.selectedUrl = "";
      },
      searchAndSelectFilterOptions() {
        this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
          const searchSelectFilter = this.options.filters.find(
            (element) => element.title === this.$t("search_and_select")
          );

          if (!searchSelectFilter) {
            return;
          }

          searchSelectFilter.option = response.data.map((name) => {
            return {
              id: name.name,
              value: name.name,
            };
          });
        });
      },
      // getPackages() {
      //   axiosGet(actions.ADMIN_CERTIFICATE)
      //     .then((res) => {
      //       this.packages = res.data.data;
      //     })
      //     .catch((error) => {
      //       
      //     });
      // },
      btnSubmit(id) {
        location.replace("/admin/stripePay/" + id);
      },
    },
  };
  </script>
  <style scoped>
  .remove_table_shadow .h-100 .datatable .table-responsive {
    box-shadow: none !important;
  }
  </style>
  
